import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { StatementsFacade } from '../../services/statements.facade';

@Component({
  standalone: false,
  selector: 'hospitable-statements-commissions-add',
  template: `
    <sbnb-full-screen-modal closeLink="/operations/statements/commissions">
      <div class="flex items-center justify-center p-8 md:p-0">
        <div class="max-w-[640px] w-full">
          <h1 class="mb-6">Set up an agreement</h1>
          <hospitable-statements-commissions-form
            (agreementChange)="updateCommission($event)"
            (formValid)="formValid = $event"></hospitable-statements-commissions-form>

          <div class="flex justify-end mt-8">
            <sbnb-button
              [loading]="(saving$ | async) === true"
              [disabled]="!formValid"
              label="Save"
              (clicked)="save()"></sbnb-button>
          </div>
        </div>
      </div>
    </sbnb-full-screen-modal>
  `,
  styleUrls: ['./statements-commissions-add.component.scss'],
})
export class StatementsCommissionsAddComponent {
  saving$ = new BehaviorSubject<boolean>(false);
  newCommission;
  formValid = true;

  constructor(
    private statementsService: StatementsFacade,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  public save() {
    this.saving$.next(true);
    this.statementsService.createCommissionAgreement(this.newCommission).subscribe({
      next: () => {
        this.saving$.next(false);
        this.returnToDashboard();
      },
      error: () => {
        this.saving$.next(false);
      },
    });
  }

  public updateCommission(commission) {
    this.newCommission = commission;
  }

  private returnToDashboard() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }
}
